"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { distributionPlanApiFetch } from "@/services/distribution-plan-api";
import type { AllowlistDescription } from "@/components/allowlist-tool/allowlist-tool.types";
import DistributionPlanToolPlansLoading from "./DistributionPlanToolPlansLoading";
import DistributionPlanToolPlansNoPlans from "./DistributionPlanToolPlansNoPlans";
import DistributionPlanToolPlansTable from "./DistributionPlanToolPlansTable";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
enum State {
  LOADING = "LOADING",
  NO_PLANS = "NO_PLANS",
  HAS_PLANS = "HAS_PLANS",
}
export default function DistributionPlanToolPlans() {
  const $ = _c(18);
  const [loading, setLoading] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [plans, setPlans] = useState(t0);
  const [state, setState] = useState(State.LOADING);
  let t1;
  if ($[1] !== loading || $[2] !== plans.length) {
    t1 = () => {
      if (loading) {
        setState(State.LOADING);
        return;
      }
      if (!plans.length) {
        setState(State.NO_PLANS);
        return;
      }
      if (plans.length) {
        setState(State.HAS_PLANS);
        return;
      }
    };
    $[1] = loading;
    $[2] = plans.length;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== loading || $[5] !== plans) {
    t2 = [loading, plans];
    $[4] = loading;
    $[5] = plans;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const getPlans = async () => {
        setLoading(true);
        const data = await distributionPlanApiFetch("/allowlists");
        setPlans(data.data ?? []);
        setLoading(false);
      };
      getPlans();
    };
    t4 = [];
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== plans) {
    t5 = id => {
      setPlans(plans.filter(plan => plan.id !== id));
    };
    $[9] = plans;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onDeleted = t5;
  let t6;
  bb0: switch (state) {
    case State.LOADING:
      {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <DistributionPlanToolPlansLoading />;
          $[11] = t7;
        } else {
          t7 = $[11];
        }
        t6 = t7;
        break bb0;
      }
    case State.NO_PLANS:
      {
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = <DistributionPlanToolPlansNoPlans />;
          $[12] = t7;
        } else {
          t7 = $[12];
        }
        t6 = t7;
        break bb0;
      }
    case State.HAS_PLANS:
      {
        let t7;
        if ($[13] !== onDeleted || $[14] !== plans) {
          t7 = <DistributionPlanToolPlansTable plans={plans} onDeleted={onDeleted} />;
          $[13] = onDeleted;
          $[14] = plans;
          $[15] = t7;
        } else {
          t7 = $[15];
        }
        t6 = t7;
        break bb0;
      }
    default:
      {
        assertUnreachable(state);
        t6 = null;
      }
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <div>{t6}</div>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}